require('metismenu');

export function enableMenu() {
  $('.sidebar-nav > ul.nav').metisMenu();
}
export function listenForResponsiveMenu() {
  $('.nav-trigger, .page-overlay').on('click', function () {
    $('.nav-trigger, .sidebar, .page-overlay').toggleClass('open');
  });
}